/**
 * @file
 * Sliders.
 */

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  /**
   * Set the same height for items.
   * @param items
   */
  function setSameHeight(items) {
    if (items.length) {
      var h = 0;
      $.each(items, function (index, el) {
        h = ($(this).height()) < h ? h : $(this).height();
      });

      $.each(items, function () {
        $(this).find('.eno-teaser').css('min-height', h + 'px');
      });
    }
  }

  Drupal.behaviors.sliders = {
    attach: function (context, settings) {
      $('.slider-items .field--items', context).each(function () {
        var slider = $(this);
        if (!slider.length) {
          return;
        }

        slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          appendArrows: $(this).siblings('.slider-navigation').find('.slick-slider-nav'),
          appendDots: $(this).siblings('.slider-navigation').find('.slick-slider-dots'),
          prevArrow: '<a class=\'btn btn-default btn-lg\'><i class="fa-solid fa-arrow-left"></i></a>',
          nextArrow: '<a class=\'btn btn-default btn-lg\'><i class="fa-solid fa-arrow-right"></i></a>',

          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })
          .on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
          });
      });

      $('.slider-items .field--items', context).each(function () {
        setSameHeight($(this));
      });
    },
  };

  Drupal.behaviors.MenuItemsSlider = {
    attach: function (context, settings) {

      $(once('menu-items-slider', '.eno-primary-navbar', context)).each(function () {
        var slider = $(this).find('ul.navbar-nav');
        var slickSliderNav = $(slider).siblings('.slider-self-nav').find('.slick-slider-nav');

        // Set width.
        function adjustBlockWidth() {
          if ($(window).width() > 1200) {
            var contentWidth = $('.region--content').width();
            $('#block-eno-primary-local-tasks').css('max-width', contentWidth);
          } else {
            $('#block-eno-primary-local-tasks').css('max-width', '');
          }
        }

        adjustBlockWidth();
        $(window).resize(adjustBlockWidth);

        if (!slider.length) {
          return;
        }

        slider.slick({
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 2,
          appendArrows: $(slickSliderNav),
          prevArrow: '<a class=\'btn btn-default prev\'><i class="chevron"></i></a>',
          nextArrow: '<a class=\'btn btn-default next\'><i class="chevron"></i></a>',

          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })
          .on('setPosition', function (event, slick) {
            // Set slides height.
            slick.$slides.css('height', slick.$slideTrack.parent().height() + 'px');
            // Set nav arrows height (Subtract the value of the borders (-3px)).
            $(slick.$nextArrow, slick.$prevArrow)
              .css('height', ($('.eno-primary-navbar').height() - 3) + 'px');
          });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
